import { Color } from './color';
import { Grupo } from './grupo';

export class Mercaderia {
  id: number;
  nombre: string;
  grupo: Grupo;
  serie: string;
  stockMin: number;
  precioCom: number;
  precioCon: number;
  precioLis: number;
  precioMay: number;
  precioDeb: number
  masVendido: boolean;
  mostrar: boolean;
  img: any;
  photo: any;
  thumb: any;
  descripcion: String;
  colores: Color[];
  ing_stock: number;
  egr_stock: number;
  ped_stock: number;

  precioOfe: number;
  cantOferta: number;
  stock: number;

  constructor() {
    this.grupo = new Grupo();
    this.colores = []
    this.masVendido = true
    this.mostrar = true
  }

}